import React, { useEffect, useState } from "react";
import PopupModal from "../../common/PopupModal";
import "./pinVerification.scss";
import brighterTextLogo from "../../assets/images/brighterTextLogo.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchProviderAuthenticateWhileLogin,
  fetchProviderPinVerification,
  fetchProviderResendVerification,
} from "../../store/Login/LoginActions";
import { useNavigate } from "react-router-dom";
// import FloatingLabelInput from "./FloatingLabelInput";
import device from "../../assets/Icons/devicesbluecheckmark.svg";

const PinVerification = ({ loginDetails, providerLoginAuth }) => {
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [isPinResent, setIsPinResent] = useState(false);
  const [pinValue, setPinValue] = useState("");

  const dispatch = useDispatch();
  const navigateTo = useNavigate();

  const { providerVerifiedToken } = useSelector(
    (state) => state.pinVerification
  );

  useEffect(() => {
    if (providerLoginAuth && !providerLoginAuth?.requiresTwoFactorVerificationPhNumber) {
      setIsModalOpen(true);
      setPinValue("");
    }
  }, [providerLoginAuth]);

  useEffect(() => {
    if (providerVerifiedToken?.userResponseDTO?.token) {
      localStorage.setItem(
        "auth-key",
        providerVerifiedToken?.userResponseDTO?.token
      );
      navigateTo("/dashboard");
      window.location.reload();
    }
  }, [providerVerifiedToken]);

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handlePinSubmit = (formData) => {
    const data = {
      deviceFingerPrint: "d485dbc29097bda4b5bc5b8325f5af46f2b036be678",
      userName: loginDetails?.userName,
      verificationCode: formData.pin,
    };
    dispatch(fetchProviderPinVerification(data)).then(() => {
      dispatch(fetchProviderAuthenticateWhileLogin(loginDetails));
    });
  };

  const handleResendPin = () => {
    const data = {
      deviceFingerPrint: "d485dbc29097bda4b5bc5b8325f5af46f2b036be678",
      userName: loginDetails?.userName,
    };
    dispatch(fetchProviderResendVerification(data)).then(() => {
      setIsPinResent(true);
      setTimeout(() => {
        setIsPinResent(false);
      }, 3000);
    });
  };

  const RenderPinVerificationContent = () => {
    return (
      <div className="login-info-content">
        <div className="row">
          <img
            className="brighterLogo"
            src={brighterTextLogo}
            alt="Brighter Logo"
            height={60}
            width={80}
          />
        </div>
        <div className="row mfa">
          <div className="col-md-8 borderRight">
            <p className="Step">2-Step Verification</p>
            <h5>Enter a verification pin</h5>
            <p className="p-3" style={{ marginBottom: "20px" }}>
              A text message with a verification pin has been sent to ***-***-**
              {providerLoginAuth?.lastTwoDigitsOfPhoneNumber
                ? providerLoginAuth?.lastTwoDigitsOfPhoneNumber
                : "**"}
            </p>
            <div className="pin-form-container">
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  const formData = new FormData(e.target);
                  const data = Object.fromEntries(formData.entries());
                  handlePinSubmit(data);
                }}
                style={{ marginBottom: "25px" }}
              >
                <div className="floating-label-container">
                  <input
                    type="text"
                    name="pin"
                    value={pinValue}
                    onChange={(e) => {
                      const alphanumeric = e.target.value
                        .replace(/[^a-zA-Z0-9]/g, "")
                        .slice(0, 6);
                      setPinValue(alphanumeric);
                    }}
                    className="floating-input"
                    required
                  />
                  <label
                    className={`floating-label ${
                      pinValue ? "floating-label-active" : ""
                    }`}
                  >
                    Enter the 6-character PIN
                  </label>
                </div>
                <button
                  type="submit"
                  className="saveBtn"
                  disabled={pinValue.length !== 6}
                  style={{
                    width: "auto",
                    padding: "8px 16px",
                    marginTop: "15px",
                  }}
                >
                  Verify
                </button>
              </form>
              <div style={{ marginBottom: "20px" }}>
                <p className="resend-text" style={{ marginBottom: "10px" }}>
                  {`Didn't receive a text?`}{" "}
                  <a
                    onClick={handleResendPin}
                    className="resend-pin-link"
                    aria-label="Resend PIN"
                  >
                    Resend PIN
                  </a>
                </p>
                {isPinResent && (
                  <p style={{ color: "red", marginTop: "5px" }}>
                    Pin sent again!
                  </p>
                )}
              </div>
              <p className="assistance-text" style={{ marginTop: "15px" }}>
                If you need assistance, call us at 424-316-2534
              </p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="pinMfaInfo">
              <img src={device} alt="Device" className="me-2 phoneIcon" />
              <p className="paraText">100% Secured</p>
              <p className="paraText">
                We take great care to protect your information.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="pin-verification-wrapper">
      {isModalOpen && (
        <PopupModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          customRender={RenderPinVerificationContent}
          popupType="center"
          width="50%"
        />
      )}
    </div>
  );
};

export default PinVerification;
